import icTrashRed from "assets/images/ic-trash-01-red.svg";
import Button from "components/commons/button";
import {ACTION_TYPE} from "constants/constant";

export const TABLE_JOB_TITLE = {
    name: 'Job Title Table',
    column: [
        {
            name: "Perusahaan",
            key: "company_name",
            classNameHeader: "!rounded-l-md",
            className: 'font-medium !text-neutral-80',
        },
        {
            name: "Job Title",
            key: "job_title_name",
        },
        {
            key: "action",
            classNameHeader: "!rounded-r-md w-[150px]",
            render: ({index, item, onClickItem}) => (
                <div className="flex justify-end gap-3 mx-auto">
                    <Button className="w-[80px]" type="outline" title="Edit"
                            onClick={() => onClickItem({index, item, actionType: ACTION_TYPE.EDIT})}/>
                    <Button type="danger" icon={icTrashRed}
                            onClick={() => onClickItem({index, item, actionType: ACTION_TYPE.DELETE})}/>
                </div>
            )
        }
    ]
}
